module.exports = __webpack_public_path__ + "static/img/logo.b816c99f.svg";